import { SearchResult } from '~/types/search/SearchResult'

export interface AutocompleteResult extends SearchResult{
  type: AutocompleteResultType
}

export enum AutocompleteResultType {
  COLLECTION
}
